import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { HttpService } from "../http-service";

//import { Observable } from 'rxjs/Rx'
import { Reciclagem } from "../../domain/reciclagem";

@Injectable()
export class ReciboProvider {
  public reciclagem: Reciclagem;

  private _urlSendMail: string = "/mail/send";
  private _urlSendSMS: string = "/sms/send";

  constructor(public http: Http, public apihttp: HttpService) {}

  enviarEmail(reciclagem: Reciclagem, email: string) {
    return new Promise((success, reject) => {
      let action = this.apihttp.post(this._urlSendMail + "/recibo", null, {
        reciclagem_id: reciclagem.id,
        emailTo: email,
      });

      action.subscribe((result: any) => {
        success(result.json().data);
      }, reject);
    });
  }

  async enviarSMS(reciclagem: any, celular) {
    return new Promise((success, reject) => {
      let action = this.apihttp.post(this._urlSendSMS + "/recibo", null, {
        reciclagem_id: reciclagem.id,
        number: celular,
      });

      action.subscribe((result: any) => {
        try {
          let r = JSON.parse(result._body);
          return r.status === "success" ? success(true) : reject(false);
        } catch (error) {
          reject(false);
        }
      }, reject);
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/reciclagem/recibo.provider.ts